export function ProblemSection() {
    return (
        <section className="py-16 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center">
                    <h2 className="text-3xl font-bold text-gray-900 mb-8">
                        The Problem with AI-Generated Content
                    </h2>
                    <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                        AI detection tools are getting more sophisticated, making it harder for AI-generated content
                        to pass as human-written. This creates challenges for content creators, marketers, and students.
                    </p>
                </div>
            </div>
        </section>
    );
}